var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8828 4.45017C14.0391 4.60637 14.0391 4.85964 13.8828 5.01585L7.42419 11.4745C6.87752 12.0212 5.99123 12.0212 5.44447 11.4747L2.11721 8.14882C1.96097 7.99264 1.96093 7.73937 2.11711 7.58314C2.27329 7.4269 2.52656 7.42685 2.68279 7.58304L6.01005 10.9089C6.24438 11.1431 6.62422 11.1431 6.85851 10.9088L13.3172 4.45017C13.4734 4.29396 13.7266 4.29396 13.8828 4.45017Z",
    fill: "#2D9BB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGroup);
export default __webpack_public_path__ + "static/media/CheckGroup.bc03db7c40f2be1bef99693b520bea3d.svg";
export { ForwardRef as ReactComponent };